import { Preferences } from "../../profile/objects/preferences";
import { Column } from "../objects/column";
import { ListPreferenceResult, setListPreference } from "../../utils/list/utils/setListPreference";
import { BANK_ACCOUNT_COLUMN, BANK_ACCOUNT_MODULE } from "../constants/accountSettingsConstants";

export const setBankAccountPreference = (new_preferences: Preferences[], state_columns: Column[]): ListPreferenceResult =>
    setListPreference(new_preferences, state_columns, {
        module: BANK_ACCOUNT_MODULE,
        default_columns: BANK_ACCOUNT_COLUMN,
        default_order_by: '',
        default_order: 'asc',
    });
